import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Select, AutoComplete, Button, Input, Form, Divider, Spin, Icon, Checkbox, Modal, Progress, Popover, message } from 'antd';

import RollingResult from './RollingResult';

import emitter from '../Evt.js';

import TooltipPage from '../../pannels/account/TooltipPage';

var moment_timezone = require('moment-timezone');

const { Option } = Select;

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class RollingPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.rollingTimer = null;

        this.user = {};
        this.state = {
            keywords: '',

            symbolsItems: [],
            symbolItems: [],

            symbolCode: '',
            symbolName: '',

            latestPrice: 0,
            quoteChange: 0,

            lastTimes: 0,

            spinLoadding: true,

            tradeDateStatus: '',
            tradeDateMessage: '',

            endOpen: false,

            IsStartBacktest: false,

            dayTradeOnly: window.webType === 'US' ? '1' : '0',

            filterError: '',

            backtestStatus: 0,
            
            statisticsResult: [],

            consuming: 0,
            percent: 0,

            visible: false,

            isHubConnection: 0
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendBacktestError", this.callSendBacktestError);
        emitter.addListener("callRollingError", this.callRollingError);
        emitter.addListener('callRollingLastTimes', this.callRollingLastTimes);
        emitter.addListener('callRollingStatus', this.callRollingStatus);
        emitter.addListener('callRollingResult', this.callRollingResult);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendBacktestError', this.callSendBacktestError);
        emitter.removeListener('callRollingError', this.callRollingError);
        emitter.removeListener('callRollingLastTimes', this.callRollingLastTimes);
        emitter.removeListener('callRollingStatus', this.callRollingStatus);
        emitter.removeListener('callRollingResult', this.callRollingResult);
    }

    callSendBacktestError = () => {
        this.setState({ spinLoadding: false });
    }

    callRollingError = (status) => {
        var error = status !== undefined ? strReplace(languageMessages['queryFail'], { '{num}': status }) : '';
        this.setState({ spinLoadding: false, filterError: error });
    }

    callRollingLastTimes = (lastTimes, permission) => {
        if (this.user.permission !== undefined) {
            this.user.permission = permission;
            sessionStorage.setItem("auth", JSON.stringify(this.user));
        }
        
        this.setState({ lastTimes, backtestStatus: 1, spinLoadding: false });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            if (value > 0) {
                value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            }
            value += sign;
        }

        return value;
    }

    callRollingStatus = (backtestStatus) => {
        backtestStatus = JSON.parse(backtestStatus || '{}');

        var consuming = parseInt(backtestStatus['consuming']);
        var percent = parseInt(backtestStatus['percent']);
        var backtestStatus = percent > 0 ? 2 : 1;
        
        this.setState({ backtestStatus, consuming, percent, spinLoadding: false });
    }

    callRollingResult = (backtestResult, backtest) => {
        backtestResult = JSON.parse(backtestResult || '[]');
        
        var statisticsResult = this.setBacktestResult(backtestResult, backtest);
        this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });

        /**
        let { consuming, percent } = this.state;
        if (consuming == 0 && percent == 0) {
            if (backtestResult.length > 0) {
                this.setProgress(backtestResult, backtest);
            } else {
                var statisticsResult = [];
                this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
            }
        } else {
            var statisticsResult = [];
            if (backtestResult.length > 0) {
                statisticsResult = this.setBacktestResult(backtestResult, backtest);
            }

            this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
        }
        */
    }

    setProgress(backtestResult, backtest) {
        var total = Math.ceil(Math.random() * (45 - 30 + 1) + 30);
        var step = Math.ceil(Math.random() * (8 - 5 + 1) + 5);

        var stepKey = Math.ceil((total - 5) / step);
        var setepValue = Math.ceil(100 / step);

        var tmpStepKey = stepKey;
        var tmpSetepValue = setepValue;

        var percentMap = { 1: 5 };
        
        stepKey += 1;
        setepValue += 5;
        percentMap[stepKey] = setepValue;
        for (var ii = 0; ii < step; ii++) {
            var stepKey1 = stepKey + tmpStepKey;

            stepKey += 1;
            stepKey = Math.ceil(Math.random() * (stepKey1 - stepKey + 1) + stepKey);

            var setepValue1 = setepValue + tmpSetepValue;

            setepValue += 1;
            setepValue = Math.ceil(Math.random() * (setepValue1 - setepValue + 1) + setepValue);

            if (ii + 1 >= step && setepValue < 98) {
                setepValue = Math.ceil(Math.random() * (98 - setepValue + 1) + setepValue);
            }
            percentMap[stepKey] = setepValue;
        }

        var consuming = 0;
        var percent = 0;
        this.setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest);
    }

    setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest) {
        if (this.state.backtestStatus === 0) return;

        consuming += 1;
        if (consuming >= total) {
            var statisticsResult = this.setBacktestResult(backtestResult, backtest);
            this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
        } else {
            if (percentMap.hasOwnProperty(consuming)) percent = percentMap[consuming];

            var _this = this;
            this.setState({ backtestStatus: 2, consuming, percent, spinLoadding: false }, () => {
                setTimeout(function () { _this.setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest); }, 1000);
            });
        }
    }

    setBacktestResult(backtestResult, backtest) {
        var statisticsResult = [];
        
        for (var item in backtestResult) {
            statisticsResult.push({
                prd1OptParent: backtestResult[item]['prd1OptParent'],
                prd1OptChild: backtestResult[item]['prd1OptChild'],

                symbol: backtest.SymbolCode,
                strategyName: backtest.GridStrategys[item].StrategyName,
                capital: backtest.GridStrategys[item].Capital,
                gridCnt: backtest.GridStrategys[item].GridCnt,

                dayTradeOnly: backtest.GridStrategys[item].DayTradeOnly,

                //prd3BacktestId: backtestResult[item]['prd3BacktestId'],

                //holdPeriod: backtestResult[item]['holdPeriod'],
                
                prd1Return: backtestResult[item]['prd1Return'],
                prd2Return: backtestResult[item]['prd2Return'],
                prd3Return: backtestResult[item]['prd3Return'],
                totalReturn: backtestResult[item]['totalReturn'],

                //targetDistance: backtestResult[item]['targetDistance'],
                //stopDistance: backtestResult[item]['stopDistance'],

                prd1EcFromDate: backtestResult[item]['prd1EcFromDate'],
                prd1EcToDate: backtestResult[item]['prd1EcToDate'],
                prd2EcFromDate: backtestResult[item]['prd2EcFromDate'],
                prd2EcToDate: backtestResult[item]['prd2EcToDate'],
                prd3EcFromDate: backtestResult[item]['prd3EcFromDate'],
                prd3EcToDate: backtestResult[item]['prd3EcToDate'],

                equityCurve: backtestResult[item]['equityCurve'],

                trades: [backtestResult[item]['trades'], backtestResult[item]['prd2Trades'], backtestResult[item]['prd3Trades']]
            });
        }

        return statisticsResult;
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_luis_sectors", payload: { UserId: user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups } });
        }
        */

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_rolling_grid", payload: { u: userId } });
    }

    setUserPermission(permissions) {
        var lastTimes = 0;
        for (var key in permissions) {
            var permission = permissions[key];
            switch (permission.type) {
                case 'rr':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                default:
                    lastTimes += 0;
                    break;
            }
        }
        this.setState({ lastTimes });
    }

    componentWillReceiveProps(props) {
        var { status, symbolItems, permission, uri, state } = props;

        switch (status) {
            case 'get_rolling_grid_success':
                if (this.user.permission !== undefined) {
                    this.user.permission = permission;
                    sessionStorage.setItem("auth", JSON.stringify(this.user));
                    this.setUserPermission(this.user.permission);
                }

                if (symbolItems === undefined || symbolItems.length == 0) {
                    symbolItems = [];
                }

                this.setState({ symbolsItems: symbolItems, spinLoadding: false });
                break;
            case 'get_rolling_grid_fail':

                this.setState({ spinLoadding: false });
                break;
            case 'get_rolling_symbols_success':
                let keywords = this.state.keywords;

                if (symbolItems !== undefined && symbolItems.length > 0) {
                    let visible = false;
                    if (keywords !== '') {
                        var tmpDataCode = symbolItems.filter(function (e) { return e.symbol.toLowerCase() === keywords.toLowerCase(); });
                        visible = tmpDataCode.length > 0 ? false : true;
                    }

                    this.setState({ symbolItems, visible });
                } else {
                    if (keywords !== '') {
                        this.setState({ symbolItems: [{ symbol: '"' + keywords.toUpperCase() + '"' + languageMessages['No strategy available'], symbolName: '' }], filterError: '', visible: true });
                    } else {
                        this.setState({
                            filterError: '',
                            symbolItems: [],
                            visible: false
                        });
                    }
                }
                break;
            case 'get_auth_success':
                const w = window.open('about:blank');
                w.location.href = uri;

                break;
            case 'get_auth_failed':
                if (state == 3) message.info(languageMessages['Authentication is normal']);
                else message.info(languageMessages['Failed to get auth url']);
                break;
            default:
                this.setState({ spinLoadding: false });
                break;
        }
    }

    handleMyBacktest = e => {
        e.preventDefault();

        history.push("/mbg");
    };

    onChangeSymbol = (symbolCode) => {
        var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

        this.setState({ keywords: symbolCode, symbolCode, IsStartBacktest, filterError: '' });
    }

    // 选择标的
    onSelectSymbol = value => {
        if (value !== '') {
            if (value.search(languageMessages['No strategy available']) === -1) {
                //languageMessages['no.matches.found']

                //var symbolItems = JSON.parse(sessionStorage.getItem("SymbolItemsCache") || '[]') || [];
                //var tmpDataCode = symbolItems.filter(function (e) { return e.stockCode.toLowerCase() === value.toLowerCase(); });
                var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

                if (tmpDataCode.length > 0) {
                    var symbolCode = tmpDataCode[0].symbol;
                    var symbolName = tmpDataCode[0].symbolName;
                    var latestPrice = parseFloat(tmpDataCode[0].close).toFixed(2);
                    var quoteChange = parseFloat(tmpDataCode[0].chg).toFixed(2);

                    var IsStartBacktest = this.checkIsStartBacktest('symbolCode', symbolCode);

                    this.setState({ keywords: value, symbolCode, symbolName, latestPrice, quoteChange, IsStartBacktest, filterError: '', visible: false }, () => {
                        //this.setBaseInfo();
                        /**
                        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
                        if (user.username === undefined) {
                            this.props.dispatch({ type: "action_non_user" });
                        } else {
                            this.props.dispatch({ type: "action_get_stock_tick", payload: { UserId: user.username, SymbolList: symbolCode } });
                        }
                        */
                    });
                }
            }
        }
    }

    onFocusSymbol = () => {
        let keywords = this.state.keywords;

        var symbolItems = this.state.symbolsItems;
        if (keywords !== null && keywords !== undefined && keywords !== '')
            symbolItems = symbolItems.filter(function (e) { return e.symbol.toLowerCase().indexOf(keywords.toLowerCase()) > -1 });

        if (symbolItems !== undefined && symbolItems.length > 0) {
            let visible = false;
            if (keywords !== '') {
                var tmpDataCode = symbolItems.filter(function (e) { return e.symbol.toLowerCase() === keywords.toLowerCase(); });
                visible = tmpDataCode.length > 0 ? false : true;
            }

            this.setState({ symbolItems, visible });
        } else {
            if (keywords !== '') {
                this.setState({ symbolItems: [{ symbol: '"' + keywords.toUpperCase() + '"' + languageMessages['No strategy available'], symbolName: '' }], filterError: '', visible: true });
            } else {
                this.setState({
                    filterError: '',
                    symbolItems: [],
                    visible: false
                });
            }
        }

        /**
        this.setState({ keywords: value, filterError: '' }, () => {
            this.props.dispatch({ type: "action_get_rolling_symbols", payload: { UserId: this.user.username, keywords: value } });
        });
        */
    }

    onBlurSymbol = value => {
        if (value !== '') {
            var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

            if (tmpDataCode.length === 0) {
                tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.substring(2, e.symbol.length) === value; });
            }

            if (tmpDataCode.length === 1) {
                var symbolCode = tmpDataCode[0].symbol;
                var symbolName = tmpDataCode[0].symbolName;
                var latestPrice = parseFloat(tmpDataCode[0].close).toFixed(2);
                var quoteChange = parseFloat(tmpDataCode[0].chg).toFixed(2);

                var IsStartBacktest = this.checkIsStartBacktest('symbolCode', symbolCode);

                this.setState({ keywords: value, symbolCode, symbolName, latestPrice, quoteChange, IsStartBacktest });
            } else {
                var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

                this.setState({
                    symbolItems: [],
                    symbolCode: '',
                    symbolName: '',
                    latestPrice: 0,
                    quoteChange: 0,
                    filterError: '',
                    keywords: '',
                    visible: false,
                    IsStartBacktest
                });
            }
        } else {
            var IsStartBacktest = this.checkIsStartBacktest('symbolCode', '');

            this.setState({
                symbolItems: [],
                symbolCode: '',
                symbolName: '',
                latestPrice: 0,
                quoteChange: 0,
                filterError: '',
                keywords: '',
                visible: false,
                IsStartBacktest
            });
        }
    }

    // 匹配标的
    handleSearch = value => {
        var keywords = value;

        var symbolItems = this.state.symbolsItems.filter(function (e) { return e.symbol.toLowerCase().indexOf(keywords.toLowerCase()) > -1 });

        if (symbolItems !== undefined && symbolItems.length > 0) {
            let visible = false;
            if (keywords !== '') {
                var tmpDataCode = symbolItems.filter(function (e) { return e.symbol.toLowerCase() === keywords.toLowerCase(); });
                visible = tmpDataCode.length > 0 ? false : true;
            }

            this.setState({ keywords, symbolItems, visible });
        } else {
            if (keywords !== '') {
                this.setState({ keywords, symbolItems: [{ symbol: '"' + keywords.toUpperCase() + '"' + languageMessages['No strategy available'], symbolName: '' }], filterError: '', visible: true });
            } else {
                this.setState({
                    keywords, 
                    filterError: '',
                    symbolItems: [],
                    visible: false
                });
            }
        }
        
        /**
        var _this = this;
        this.setState({ keywords: value, filterError: '', visible: false }, () => {
            
            if (_this.rollingTimer) {
                clearTimeout(_this.rollingTimer);
                _this.rollingTimer = null;
            }
            
            _this.rollingTimer = setTimeout(function () {
                _this.props.dispatch({ type: "action_get_rolling_symbols", payload: { UserId: _this.user.username, keywords: value } });
            }, 500);
        });
        */
    };

    handleChangeDayTradeOnly = e => {
        var dayTradeOnly = e.target.checked;

        this.setState({ dayTradeOnly });
    }

    checkIsStartBacktest(type, value) {
        var IsStartBacktest = false;
        let { symbolCode } = this.state;

        switch (type) {
            case 'symbolCode':
                symbolCode = value;
                break;
            default:
                break;
        }

        if (symbolCode != '') {
            IsStartBacktest = true;
        }

        return IsStartBacktest;
    }

    onStartBacktest = () => {
        if (this.user.username === undefined) {
            this.setState({
                filterError: '',
                spinLoadding: false,
            }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            let { symbolCode, symbolName, lastTimes, latestPrice, dayTradeOnly } = this.state;

            if (lastTimes <= 0) {
                var content = <span>{languageMessages['todayQueryNumberRunOut']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            }

            window._hmt && window._hmt.push(['_trackEvent', 'Consistent return', 'Backtest', 'Consistent return']);

            this.setState({
                backtestStatus: 0,
                statisticsResult: [],
                consuming: 0,
                percent: 0,
                spinLoadding: true,
                filterError: ''
            }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendBacktest', userId: this.user.username,
                        msg: {
                            Type: 'rollingBacktest',
                            SymbolCode: symbolCode,
                            SymbolName: symbolName,
                            DayTradeOnly: dayTradeOnly,// ? '1' : '0',
                            Last: latestPrice,
                            reqId: guid()
                        }
                    }
                });
            });
        }
    }

    importBacktestResult = () => {
        //console.log('import');
    }

    back = () => {
        return (<div>
            <span style={{ margin: '0 10px' }}>{strReplace(languageMessages['queryingConsuming'], { '{num}': this.state.consuming })}</span>
            <span style={{ display: 'inline-block', width: '300px', margin: '0 10px' }}><Progress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} percent={this.state.percent} /></span>
        </div>)
    }

    render() {
        var { symbolItems, symbolCode, percent, visible, keywords } = this.state;

        if (symbolCode.search(languageMessages['No strategy available']) !== -1) {
            symbolCode = symbolCode.replace(languageMessages['No strategy available'], '');
            symbolCode = symbolCode.substring(1, symbolCode.length - 1);
        }

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['rollingStrategy']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px', marginBottom: '20px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['Basic Information']}</div>
                    <div style={{ padding: '10px 0' }}>
                        <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item colon={false} label={languageMessages['symbolCode']} style={{ marginBottom: 0, marginRight: 32 }}>
                                <Popover
                                    placement="topLeft"
                                    content={(<span style={{ padding: '16px' }}>{strReplace(languageMessages['No strategy available for aymbol'], { '{symbol}': keywords.toUpperCase() })}</span>)}
                                    trigger=""
                                    visible={visible}>
                                    <AutoComplete value={symbolCode}
                                        className="certain-category-search"
                                        dropdownClassName="certain-category-search-dropdown"
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ width: 200 }}
                                        size="small"
                                        style={{ width: '200px' }}
                                        dataSource={symbolItems.map(group => (
                                            <Option key={group.symbol} value={group.symbol}>
                                                {group.symbol}
                                                <span className="certain-search-item-count">{group.symbolName}</span>
                                            </Option>
                                        ))}
                                        onChange={this.onChangeSymbol}
                                        onSearch={this.handleSearch}
                                        onSelect={this.onSelectSymbol}
                                        onFocus={this.onFocusSymbol}
                                        onBlur={this.onBlurSymbol}
                                        placeholder={languageMessages['pleaseEnterSymbolCode']}
                                        optionLabelProp="value">
                                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                    </AutoComplete>
                                </Popover>
                                <div style={{ position: 'relative', top: '-5px', height: '20px', lineHeight: '20px', fontSize: '10px' }}>
                                    {languageMessages['latest']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.85)', marginRight: '10px' }}>{this.state.latestPrice}</span>
                                    {languageMessages['quote.change']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : this.state.quoteChange >= 0 ? window.webType === 'US' ? 'green' : 'red' : window.webType === 'US' ? 'red' : 'green' }}>{this.state.quoteChange}%</span>
                                </div>
                            </Form.Item>
                            <Form.Item>
                                <Button size='small' loading={false} disabled={!this.state.IsStartBacktest} onClick={this.onStartBacktest}>
                                    {languageMessages['getRollingStrategy']}
                                </Button>
                                <TooltipPage lastTimes={this.state.lastTimes} filterError={this.state.filterError} lineHeight={14} />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                <div style={{ backgroundColor: '#efefef', height: '48px', lineHeight: '48px', padding: '0 50px', display: this.state.backtestStatus > 0 ? 'block' : 'none' }}>
                    <div style={{ float: 'left' }}>
                        <b>{languageMessages['status']}</b>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 1 ? 'inline-block' : 'none' }}>{languageMessages['queue']}</span>
                        <span style={{ display: this.state.backtestStatus == 2 ? 'inline-block' : 'none' }}>
                            <span style={{ margin: '0 10px' }}>{languageMessages['query prompt']}</span>
                        </span>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 3 ? 'inline-block' : 'none' }}>{this.state.statisticsResult.length > 0 ? languageMessages['queryingCompletedConsuming'] : languageMessages['No strategy found for this security']}</span>
                    </div>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {this.state.statisticsResult.length == 0 || (<RollingResult dispatch={this.props.dispatch} status={this.props.status} basePosition={this.props.basePosition} share={this.props.share} statisticsResult={this.state.statisticsResult} />)}
                </Content>
        </Spin>
    </Content>);
    }
}

function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(RollingPage);
export { page as default }